module.exports = __webpack_public_path__ + "media/images/articles/job_motivation/thumb-71c8b48bdfcb46670bc0b73870b0d1fa.png";